// extracted by mini-css-extract-plugin
module.exports = {"button":"SideNavButton_button__B12m0","selected":"SideNavButton_selected__2N69R"};